import './Card.css';
export default {
    "card--contained": "Card_card--contained__g6xh3",
    "card--stretched": "Card_card--stretched__g6xh3",
    "contentWrapper": "Card_contentWrapper__g6xh3",
    "body": "Card_body__g6xh3",
    "title": "Card_title__g6xh3",
    "readMore": "Card_readMore__g6xh3"
};
